import React from 'react'
import { IconButton } from '@doseme/cohesive-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

import './index.scss'

interface IProps {
  module: string
  name: string
  id: number
  checked: boolean
  count: number
  handleListSelect: (e: React.FormEvent<any>) => void
  handleRemove: (evt: React.FormEvent<HTMLButtonElement>, entitlement: number) => void
}

const DrugItem: React.FC<IProps> = (props) => {
  let className = 'drugCheckbox'
  className +=  props.checked ? ' drug-item-selected' : ''
  // used for selecting the module in testing
  // transform `DoseMe::Drugs::Vancomycin` into `doseme-drugs-vancomycin`
  const moduleName = props.module.replace(/::/gi, '-').toLowerCase()
  className += ` ${moduleName}-data-test-wrapper`

  const countDisplay = props.count > 0
    ? <span>{props.count}</span>
    : <FontAwesomeIcon className='fa-xs' data-testid='unlimited-checkmark' icon={faCheck} />

  const badge = (
    <div className={props.count === 0 ? 'drug-icons badge-none' : 'drug-icons'}>
      <IconButton
        className='mr-1 remove-entitlement-btn'
        data-testid='remove-entitlement'
        onClick={evt => props.handleRemove(evt, props.id)}
        size='18px'
        background='none'
        color='red'
      >
        <FontAwesomeIcon className='remove-icon' icon={faTimes} />
      </IconButton>
      <div
        className={props.count > 0 ? 'badge badge-count' : 'badge'}
        data-testid='entitlements-count'
      >
        {countDisplay}
      </div>
    </div>
  )

  const label = (
    <small
      key={props.module}
      className='d-flex justify-content-between w-100 drug-label'
    >
      <div
        className='drug-name'
        data-test='entitlement-drug-name'
      >{props.name}</div>
      {badge}
    </small>
  )

  return (
    <div className='d-flex drug-item-wrapper'>
      <input
        type='checkbox'
        className={className}
        data-testid={props.module}
        id={props.module}
        key={props.module}
        value={props.id}
        onChange={props.handleListSelect}
        checked={props.checked}
      />
      <label htmlFor={props.module}>{label}</label>
    </div>
  )
}

export {
  DrugItem
}
